import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing-module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatIconModule } from '@angular/material/icon';
import { LocalizationCacheService } from './core/services/localization-cache/localization-cache.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthService } from './auth/services/auth/auth.service';
import { MsalModule, MsalRedirectComponent, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { CredentialsInterceptor } from './core/interceptors/credentials/credentials-interceptor';
import { msalConfig } from './auth/config/auth.config';
import { AuthTokenInterceptor } from './core/interceptors/token/auth-token.interceptor';
export const msalInstance: IPublicClientApplication = new PublicClientApplication(msalConfig);
export function HttpLoaderFactory(http: HttpClient, localizationCacheService: LocalizationCacheService): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '/assets/i18n/', `.json?loadedDate=${localizationCacheService.getCacheBuster()}`);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
 
     MsalModule.forRoot(
      MSALInstanceFactory(),
      {
        interactionType: InteractionType.Redirect, // or Popup
        authRequest: { scopes: ['User.Read'] },
      },
      
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['User.Read']]
        ])
      }
    ),
    BrowserModule,
    AppRoutingModule,
    MatIconModule,
    HttpClientModule,
    
    // ✅ i18n setup with ngx-translate
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient, LocalizationCacheService],
      }
    }),
    
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
     {
      provide: APP_INITIALIZER,
      useFactory: initializeMsalInstance,
          deps: [AuthService], // Add AuthService here

      multi: true,
    },
   {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }


export function MSALInstanceFactory(): IPublicClientApplication {
  return msalInstance;
}
export function initializeMsalInstance(authService: AuthService) {
  return async () => {
    await msalInstance.initialize();
    // Handle redirect from Azure login
    await authService.handleRedirectCallback();
  };
}

